export const engReg = /[a-z]+/i;
export const rusReg = /[а-я]+/i;
// export const symbolReg = /[^!@%#%:;'\\"+.=\-*\\(\\)\\[]\{}\/]+/g;
export const symbolReg = /[?![\]%\\/&,'";:\-+@#$^*)(=.|\s]+/gis;
export const routes = {
  login: '/',
  // registration: '/registration',
  projects: '/projects',
  logs: '/logs',
  users: '/users',
  // forgotPasswordSuccess: '/forgotPasswordSuccess',
  // changeMail: '/changeMail',
  tableAllProjects: '/projects/allProjects',
  documentProcessing: '/projects/allProjects/documentProcessing',
  // invoices: '/documents/invoices',
  // drafts: '/documents/drafts',
  // templates: '/documents/templates',
  // customers1: '/customers/1',
  // customers2: '/customers/2',
  // settings: '/settings',
  // help: '/help',
};

export const localStorage = {
  token: 'token',
};

export default class Types {
  static statusConstants = {
    active: 1, //Активный
    draft: 2, //Черновик
    archive: 3, //Архив
  };
  static logOutLink = 'http://r42-rc.zdrav.netrika.ru/acs2/acs/connect/endsession';
  static applicationTooltipMessage =
    'Заявка уже подана. Внесённые изменения будут учтены при формировании витрины';
  static testApplicationTooltipMessage =
    'Заявка уже подана. Внесённые изменения будут учтены при формировании тестовой витрины';
  static initUnsavedChanges = {
    general: false,
    CDA: false,
    target_showcase: false,
  };
  static initTabs = {
    general: 'general',
    CDA: 'CDA',
    target_showcase: 'target_showcase',
  };
  static labelNames = {
    englishName: 'Код',
    russianName: 'Название на русском',
  };
  static errorEngNameMessage =
    'Разрешён ввод только латинских символов, цифр и символа подчёркивания. Можно: cda_date. Нельзя: Дата cda';
  static appSizes = [
    { id: 0, key: 'mobile', size: 360 },
    { id: 1, key: 'tablet', size: 768 },
    { id: 2, key: 'desktop', size: 1152 },
    { id: 3, key: 'large', size: 1440 },
    { id: 4, key: 'plug', size: 360 },
  ];

  static appSizesMap = Types.appSizes.reduce(
    (acc, item) => acc.set(item.key, { ...item }),
    new Map(),
  );
}
